import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DeleteError: any;
};

export type Artist = Entity & {
  __typename?: 'Artist';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type ArtistEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Asset = {
  __typename?: 'Asset';
  asset_type?: Maybe<Scalars['String']>;
  bibliography_reference?: Maybe<Translation>;
  children?: Maybe<Array<Maybe<Asset>>>;
  client_reference?: Maybe<Scalars['String']>;
  condition?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  current_gmaps?: Maybe<Scalars['String']>;
  current_location?: Maybe<Translation>;
  customId?: Maybe<Scalars['String']>;
  custom_dimensions?: Maybe<Translation>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  description?: Maybe<Translation>;
  dimensions?: Maybe<Dimension>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  etag?: Maybe<Scalars['String']>;
  exhibited?: Maybe<Translation>;
  id: Scalars['ID'];
  inscriptions?: Maybe<Translation>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  last_modified?: Maybe<Scalars['ID']>;
  literature?: Maybe<Translation>;
  loan?: Maybe<Translation>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  observations?: Maybe<Translation>;
  organization?: Maybe<Organization>;
  original_gmaps?: Maybe<Scalars['String']>;
  original_location?: Maybe<Translation>;
  parent?: Maybe<Asset>;
  price?: Maybe<AssetPrice>;
  priority?: Maybe<Scalars['Int']>;
  provenance?: Maybe<Translation>;
  publications?: Maybe<Translation>;
  related_links?: Maybe<Array<Maybe<AssetRelatedLink>>>;
  sale_status?: Maybe<Scalars['String']>;
  scientific_tests?: Maybe<Translation>;
  series?: Maybe<Translation>;
  signed_dated_labeled?: Maybe<Translation>;
  storage_location?: Maybe<Translation>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  visibility?: Maybe<AssetVisibility>;
};

export type AssetContext = {
  __typename?: 'AssetContext';
  asset?: Maybe<Asset>;
  collection?: Maybe<Collection>;
  creation_date?: Maybe<Scalars['ID']>;
  description?: Maybe<Translation>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  position?: Maybe<Array<Maybe<Scalars['Float']>>>;
  relatedAssets?: Maybe<Array<Maybe<Scalars['ID']>>>;
  room?: Maybe<Room>;
  rotation?: Maybe<Scalars['String']>;
  sale_status?: Maybe<Scalars['String']>;
  sortIndex?: Maybe<Scalars['Int']>;
  viewpointId?: Maybe<Scalars['String']>;
};

export type AssetContextFilteringInput = {
  asset_type?: InputMaybe<AssetType>;
};

export type AssetContextInput = {
  asset?: InputMaybe<Scalars['ID']>;
  collection?: InputMaybe<Scalars['ID']>;
  collectionType?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<TranslationInput>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  relatedAssets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  room?: InputMaybe<Scalars['ID']>;
  rotation?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  viewpointId?: InputMaybe<Scalars['String']>;
};

export type AssetContextsInput = {
  asset?: InputMaybe<Scalars['ID']>;
  collection?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<TranslationInput>;
  position?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  room?: InputMaybe<Scalars['ID']>;
  rotation?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  viewpointId?: InputMaybe<Scalars['String']>;
};

export type AssetContextsList = {
  __typename?: 'AssetContextsList';
  data?: Maybe<Array<Maybe<AssetContext>>>;
  meta?: Maybe<PageMeta>;
};

export type AssetFilteringInput = {
  asset_type?: InputMaybe<AssetType>;
  client_reference?: InputMaybe<Scalars['String']>;
  customId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sale_status?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<AssetVisibility>;
};

export type AssetGroup = {
  __typename?: 'AssetGroup';
  assets?: Maybe<Array<Maybe<Asset>>>;
  creation_date?: Maybe<Scalars['ID']>;
  description?: Maybe<Scalars['String']>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  set?: Maybe<Scalars['String']>;
  type?: Maybe<AssetGroupType>;
  url?: Maybe<Scalars['String']>;
  viewer?: Maybe<Scalars['String']>;
};

export type AssetGroupFilteringInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssetGroupInputType>;
};

export type AssetGroupInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  creation_date?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  set?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<AssetGroupInputType>;
  url?: InputMaybe<Scalars['String']>;
  viewer?: InputMaybe<Scalars['String']>;
};

export type AssetGroupList = {
  __typename?: 'AssetGroupList';
  data?: Maybe<Array<Maybe<AssetGroup>>>;
  meta?: Maybe<PageMeta>;
};

export type AssetInput = {
  asset_type?: InputMaybe<AssetType>;
  bibliography_reference?: InputMaybe<TranslationInput>;
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  client_reference?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  current_gmaps?: InputMaybe<Scalars['String']>;
  current_location?: InputMaybe<TranslationInput>;
  customId?: InputMaybe<Scalars['String']>;
  custom_dimensions?: InputMaybe<TranslationInput>;
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  description?: InputMaybe<LongTranslationInput>;
  dimensions?: InputMaybe<DimensionInput>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  etag?: InputMaybe<Scalars['String']>;
  exhibited?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  inscriptions?: InputMaybe<TranslationInput>;
  last_modified?: InputMaybe<Scalars['ID']>;
  literature?: InputMaybe<TranslationInput>;
  loan?: InputMaybe<TranslationInput>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  observations?: InputMaybe<TranslationInput>;
  organization?: InputMaybe<Scalars['ID']>;
  original_gmaps?: InputMaybe<Scalars['String']>;
  original_location?: InputMaybe<TranslationInput>;
  parent?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<AssetPriceInput>;
  priority?: InputMaybe<Scalars['Int']>;
  provenance?: InputMaybe<TranslationInput>;
  publications?: InputMaybe<TranslationInput>;
  related_links?: InputMaybe<Array<InputMaybe<AssetInputRelatedLink>>>;
  sale_status?: InputMaybe<Scalars['String']>;
  scientific_tests?: InputMaybe<TranslationInput>;
  series?: InputMaybe<TranslationInput>;
  signed_dated_labeled?: InputMaybe<TranslationInput>;
  storage_location?: InputMaybe<TranslationInput>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  visibility?: InputMaybe<AssetVisibility>;
};

export type AssetInputRelatedLink = {
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
};

export type AssetPrice = {
  __typename?: 'AssetPrice';
  final_price?: Maybe<Price>;
  purchase_price?: Maybe<Price>;
  sale_price?: Maybe<Price>;
  taxes?: Maybe<Price>;
};

export type AssetPriceInput = {
  final_price?: InputMaybe<PriceInput>;
  purchase_price?: InputMaybe<PriceInput>;
  sale_price?: InputMaybe<PriceInput>;
  taxes?: InputMaybe<PriceInput>;
};

export type AssetRelatedLink = {
  __typename?: 'AssetRelatedLink';
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
};

export enum AssetType {
  Artwork = 'artwork',
  InfoPoint = 'info_point',
  Museum = 'museum',
  Pointofinterest = 'pointofinterest'
}

export enum AssetVisibility {
  Hidden = 'hidden',
  Public = 'public'
}

export type AssetsList = {
  __typename?: 'AssetsList';
  data?: Maybe<Array<Maybe<Asset>>>;
  meta?: Maybe<PageMeta>;
};

export type BatchCollectionInputObjectType = {
  Exhibition?: InputMaybe<ExhibitionCollectionInput>;
  ViewingRoom?: InputMaybe<ViewingRoomCollectionInput>;
};

export type BatchEntityInputObjectType = {
  Artist?: InputMaybe<ArtistEntityInput>;
  Culture?: InputMaybe<CultureEntityInput>;
  Date?: InputMaybe<DateEntityInput>;
  Location?: InputMaybe<LocationEntityInput>;
  Material?: InputMaybe<MaterialEntityInput>;
  Other?: InputMaybe<OtherEntityInput>;
  Period?: InputMaybe<PeriodEntityInput>;
  Subculture?: InputMaybe<SubcultureEntityInput>;
  Technique?: InputMaybe<TechniqueEntityInput>;
  Typology?: InputMaybe<TypologyEntityInput>;
};

export type Boundaries = {
  __typename?: 'Boundaries';
  value?: Maybe<Scalars['String']>;
};

export type BoundariesInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type Collection = {
  assetContextsCount?: Maybe<Scalars['Int']>;
  audio_description?: Maybe<Media>;
  collectionType?: Maybe<Scalars['ID']>;
  cover_img?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  dark_logo_img?: Maybe<Scalars['String']>;
  description?: Maybe<Translation>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  etag?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  light_logo_img?: Maybe<Scalars['String']>;
  logo_img?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  organization?: Maybe<Organization>;
  related_links?: Maybe<Array<Maybe<CollectionRelatedLink>>>;
  sharedOrganizations?: Maybe<Array<Maybe<Organization>>>;
  visibility?: Maybe<CollectionVisibility>;
  web_entities?: Maybe<Array<Maybe<WebEntity>>>;
};

export type CollectionField = {
  __typename?: 'CollectionField';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CollectionFieldInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CollectionFilteringInput = {
  collectionType?: InputMaybe<Scalars['String']>;
  customId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CollectionInputRelatedLink = {
  link?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
};

export type CollectionRelatedLink = {
  __typename?: 'CollectionRelatedLink';
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
};

export type CollectionStyling = {
  __typename?: 'CollectionStyling';
  accent_color?: Maybe<Scalars['String']>;
  background_color?: Maybe<Scalars['String']>;
  font_style?: Maybe<FontStyleType>;
  fullscreen_button?: Maybe<Scalars['Boolean']>;
  info_color?: Maybe<Scalars['String']>;
  info_panel_color?: Maybe<Scalars['String']>;
  menu_color?: Maybe<Scalars['String']>;
  node_color?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
};

export type CollectionStylingInput = {
  accent_color?: InputMaybe<Scalars['String']>;
  background_color?: InputMaybe<Scalars['String']>;
  font_style?: InputMaybe<FontStyleInputType>;
  fullscreen_button?: InputMaybe<Scalars['Boolean']>;
  info_color?: InputMaybe<Scalars['String']>;
  info_panel_color?: InputMaybe<Scalars['String']>;
  menu_color?: InputMaybe<Scalars['String']>;
  node_color?: InputMaybe<Scalars['String']>;
  theme?: InputMaybe<Scalars['String']>;
};

export type CollectionType = {
  __typename?: 'CollectionType';
  customId?: Maybe<Scalars['ID']>;
  fields?: Maybe<Array<Maybe<CollectionField>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type CollectionTypeInput = {
  customId?: InputMaybe<Scalars['ID']>;
  fields?: InputMaybe<Array<InputMaybe<CollectionFieldInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export enum CollectionVisibility {
  Hidden = 'hidden',
  Public = 'public'
}

export type CollectionsList = {
  __typename?: 'CollectionsList';
  data?: Maybe<Array<Maybe<Collection>>>;
  meta?: Maybe<PageMeta>;
};

export type Culture = Entity & {
  __typename?: 'Culture';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type CultureEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type CustomEntity = {
  __typename?: 'CustomEntity';
  name?: Maybe<Translation>;
  published?: Maybe<Translation>;
  type?: Maybe<Scalars['String']>;
};

export type CustomEntityInput = {
  name?: InputMaybe<TranslationInput>;
  published?: InputMaybe<TranslationInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type Date = Entity & {
  __typename?: 'Date';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type DateEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  error?: Maybe<Scalars['DeleteError']>;
  message?: Maybe<Scalars['String']>;
};

export type Dimension = {
  __typename?: 'Dimension';
  depth?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  units?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type DimensionInput = {
  depth?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  units?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type EntitiesList = {
  __typename?: 'EntitiesList';
  data?: Maybe<Array<Maybe<Entity>>>;
  meta?: Maybe<PageMeta>;
};

export type Entity = {
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  entityType?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
};

export type EntityField = {
  __typename?: 'EntityField';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EntityFieldInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type EntityFilteringInput = {
  customId?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EntityType = {
  __typename?: 'EntityType';
  customId?: Maybe<Scalars['ID']>;
  fields?: Maybe<Array<Maybe<EntityField>>>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Translation>;
};

export type EntityTypeInput = {
  customId?: InputMaybe<Scalars['ID']>;
  fields?: InputMaybe<Array<InputMaybe<EntityFieldInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<TranslationInput>;
};

export type Exhibition = Collection & {
  __typename?: 'Exhibition';
  assetContextsCount?: Maybe<Scalars['Int']>;
  audio_background?: Maybe<Media>;
  audio_description?: Maybe<Media>;
  available_languages?: Maybe<Array<Maybe<Language>>>;
  collectionType?: Maybe<Scalars['ID']>;
  cover_img?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  dark_logo_img?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  description?: Maybe<Translation>;
  disable_audios?: Maybe<Scalars['Boolean']>;
  dvm_set_id?: Maybe<Scalars['String']>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  etag?: Maybe<Scalars['String']>;
  exhibitionType?: Maybe<ExhibitionType>;
  id?: Maybe<Scalars['ID']>;
  init_pano?: Maybe<Scalars['String']>;
  init_questions?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Translation>;
  last_modified?: Maybe<Scalars['ID']>;
  light_logo_img?: Maybe<Scalars['String']>;
  login_applied?: Maybe<Scalars['Boolean']>;
  logo_img?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  organization?: Maybe<Organization>;
  organizer?: Maybe<ExhibitionOrganizer>;
  passwords?: Maybe<Translation>;
  questions?: Maybe<Array<Maybe<Question>>>;
  related_links?: Maybe<Array<Maybe<CollectionRelatedLink>>>;
  sharedOrganizations?: Maybe<Array<Maybe<Organization>>>;
  styling?: Maybe<CollectionStyling>;
  subtitle?: Maybe<Translation>;
  theme_song?: Maybe<Scalars['String']>;
  title?: Maybe<Translation>;
  venueConfig?: Maybe<VenueConfiguration>;
  viewer?: Maybe<Scalars['String']>;
  visibility?: Maybe<CollectionVisibility>;
  web_entities?: Maybe<Array<Maybe<WebEntity>>>;
};

export type ExhibitionCollectionInput = {
  assetContexts?: InputMaybe<Array<InputMaybe<AssetContextsInput>>>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  audio_background?: InputMaybe<MediaInput>;
  audio_description?: InputMaybe<MediaInput>;
  available_languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionType?: InputMaybe<Scalars['ID']>;
  cover_img?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId?: InputMaybe<Scalars['ID']>;
  dark_logo_img?: InputMaybe<Scalars['String']>;
  default_language?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<LongTranslationInput>;
  disable_audios?: InputMaybe<Scalars['Boolean']>;
  dvm_set_id?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  etag?: InputMaybe<Scalars['String']>;
  exhibitionType?: InputMaybe<ExhibitionType>;
  id?: InputMaybe<Scalars['ID']>;
  init_pano?: InputMaybe<Scalars['String']>;
  init_questions?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<TranslationInput>;
  last_modified?: InputMaybe<Scalars['ID']>;
  light_logo_img?: InputMaybe<Scalars['String']>;
  login_applied?: InputMaybe<Scalars['Boolean']>;
  logo_img?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
  organization?: InputMaybe<Scalars['ID']>;
  organizer?: InputMaybe<ExhibitionOrganizerInput>;
  passwords?: InputMaybe<TranslationInput>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  related_links?: InputMaybe<Array<InputMaybe<CollectionInputRelatedLink>>>;
  rooms?: InputMaybe<Array<InputMaybe<RoomsInput>>>;
  sharedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  styling?: InputMaybe<CollectionStylingInput>;
  subtitle?: InputMaybe<TranslationInput>;
  theme_song?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<TranslationInput>;
  venueConfig?: InputMaybe<Scalars['ID']>;
  viewer?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<CollectionVisibility>;
  web_entities?: InputMaybe<Array<InputMaybe<WebEntityInput>>>;
};

export type ExhibitionOrganizer = {
  __typename?: 'ExhibitionOrganizer';
  logos?: Maybe<Array<Maybe<Media>>>;
  title?: Maybe<Translation>;
};

export type ExhibitionOrganizerInput = {
  logos?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  title?: InputMaybe<TranslationInput>;
};

export type ExhibitionPassword = {
  __typename?: 'ExhibitionPassword';
  expiration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ExhibitionPasswordInput = {
  expiration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  url?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export enum ExhibitionType {
  Architecture = 'architecture',
  Artworks = 'artworks',
  Assets = 'assets',
  Custom = 'custom',
  Images = 'images',
  Metae = 'metae',
  Photographs = 'photographs'
}

export type Invoice = {
  __typename?: 'Invoice';
  asset?: Maybe<Scalars['ID']>;
  creation_date?: Maybe<Scalars['ID']>;
  date?: Maybe<Scalars['Int']>;
  file?: Maybe<Media>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  organization?: Maybe<Scalars['ID']>;
  price?: Maybe<InvoicePrice>;
};

export type InvoiceInput = {
  asset?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Int']>;
  file?: InputMaybe<MediaInput>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  price?: InputMaybe<InvoicePriceInput>;
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  data?: Maybe<Array<Maybe<Invoice>>>;
  meta?: Maybe<PageMeta>;
};

export type InvoicePrice = {
  __typename?: 'InvoicePrice';
  currency?: Maybe<Scalars['String']>;
  final_price?: Maybe<Scalars['Float']>;
  iva_value?: Maybe<Scalars['Int']>;
  sale_price?: Maybe<Scalars['Float']>;
  shipment?: Maybe<Scalars['Float']>;
  tax?: Maybe<InvoiceTaxEnum>;
};

export type InvoicePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  final_price?: InputMaybe<Scalars['Float']>;
  iva_value?: InputMaybe<Scalars['Int']>;
  sale_price?: InputMaybe<Scalars['Float']>;
  shipment?: InputMaybe<Scalars['Float']>;
  tax?: InputMaybe<InvoiceTaxInputEnum>;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['ID'];
  id?: Maybe<Scalars['ID']>;
  logo_path?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LanguageInput = {
  code?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  logo_path?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Location = Entity & {
  __typename?: 'Location';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type LocationEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type LongTranslationInput = {
  ca?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
  es?: InputMaybe<Scalars['String']>;
  it?: InputMaybe<Scalars['String']>;
};

export type Manager = {
  __typename?: 'Manager';
  creation_date?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  firstname?: Maybe<Scalars['String']>;
  frontAccessList?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  lastname?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<RoleType>;
  role_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  status?: Maybe<StatusType>;
  username?: Maybe<Scalars['ID']>;
};

export type ManagerInput = {
  creation_date?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  frontAccessList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  lastname?: InputMaybe<Scalars['String']>;
  organization: Scalars['ID'];
  password?: InputMaybe<Scalars['String']>;
  password_confirmation?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<RoleType>;
  role_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<StatusType>;
  username?: InputMaybe<Scalars['ID']>;
};

export type ManagerPagination = {
  __typename?: 'ManagerPagination';
  current_page?: Maybe<Scalars['Int']>;
  first_page?: Maybe<Scalars['Int']>;
  last_page?: Maybe<Scalars['Int']>;
  per_page?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Material = Entity & {
  __typename?: 'Material';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type MaterialEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Media = {
  __typename?: 'Media';
  description?: Maybe<Translation>;
  hd?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  lang?: Maybe<Array<Maybe<Scalars['String']>>>;
  model3d?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  originalName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  type?: Maybe<MediaType>;
  url?: Maybe<Scalars['String']>;
  view_image?: Maybe<Scalars['String']>;
};

export type MediaInput = {
  description?: InputMaybe<TranslationInput>;
  hd?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  lang?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  model3d?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  originalName?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  thumbnail?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<MediaType>;
  url?: InputMaybe<Scalars['String']>;
  view_image?: InputMaybe<Scalars['String']>;
};

export enum MediaType {
  Acquisition = 'acquisition',
  AudioBackground = 'audioBackground',
  AudioDescription = 'audioDescription',
  AudioTitle = 'audioTitle',
  CertificateAuthenticity = 'certificateAuthenticity',
  ConditionReport = 'conditionReport',
  ContractsAndLoans = 'contractsAndLoans',
  Cost = 'cost',
  DatasheetDoc = 'datasheetDoc',
  ExportPermit = 'exportPermit',
  GeneralDoc = 'generalDoc',
  Hd = 'hd',
  ImageCarousel = 'imageCarousel',
  ImageDoc = 'imageDoc',
  ImageParallel = 'imageParallel',
  ImageRelated = 'imageRelated',
  ImageThumb = 'imageThumb',
  ImageThumbHover = 'imageThumbHover',
  ImportPermit = 'importPermit',
  InsuranceAndValuations = 'insuranceAndValuations',
  Invoice = 'invoice',
  LiteratureAndPublications = 'literatureAndPublications',
  Model3d = 'model3d',
  Other = 'other',
  Provenance = 'provenance',
  RightsAndPermissions = 'rightsAndPermissions',
  Shipping = 'shipping',
  TechnicalspecsDoc = 'technicalspecsDoc',
  Videolink = 'videolink'
}

export type Mutation = {
  __typename?: 'Mutation';
  addPassword?: Maybe<Scalars['Boolean']>;
  batchWriteAsset?: Maybe<BatchAssets>;
  batchWriteAssetGroup?: Maybe<AssetGroup>;
  batchWriteCollection?: Maybe<BatchCollections>;
  batchWriteEntity?: Maybe<BatchEntities>;
  batchWriteInvoice?: Maybe<Invoice>;
  batchWriteVenue?: Maybe<Array<Maybe<Venue>>>;
  cloneCollection?: Maybe<Collection>;
  createAsset?: Maybe<Asset>;
  createAssetContext?: Maybe<AssetContext>;
  createAssetContextByCustomId?: Maybe<AssetContext>;
  createAssetGroup?: Maybe<AssetGroup>;
  createCollection?: Maybe<Collection>;
  createCollectionType?: Maybe<CollectionType>;
  createEntity?: Maybe<Entity>;
  createEntityType?: Maybe<EntityType>;
  createInvoice?: Maybe<Invoice>;
  createLanguage?: Maybe<Language>;
  createManager?: Maybe<Manager>;
  createOrganization?: Maybe<Organization>;
  createSecret?: Maybe<Secret>;
  createTag?: Maybe<Tag>;
  createVenue?: Maybe<Venue>;
  deleteAsset?: Maybe<DeleteResponse>;
  deleteAssetContext?: Maybe<DeleteResponse>;
  deleteAssetContexts?: Maybe<DeleteResponse>;
  deleteAssetGroup?: Maybe<DeleteResponse>;
  deleteAssetGroups?: Maybe<DeleteResponse>;
  deleteAssets?: Maybe<DeleteResponse>;
  deleteCollection?: Maybe<DeleteResponse>;
  deleteCollectionType?: Maybe<DeleteResponse>;
  deleteCollections?: Maybe<DeleteResponse>;
  deleteEntities?: Maybe<DeleteResponse>;
  deleteEntity?: Maybe<DeleteResponse>;
  deleteEntityType?: Maybe<DeleteResponse>;
  deleteInvoice?: Maybe<DeleteResponse>;
  deleteInvoices?: Maybe<DeleteResponse>;
  deleteManager?: Maybe<DeleteResponse>;
  deleteOrganization?: Maybe<DeleteResponse>;
  deleteOrganizations?: Maybe<DeleteResponse>;
  deleteSecret?: Maybe<DeleteResponse>;
  deleteVenue?: Maybe<DeleteResponse>;
  generateSharingToken?: Maybe<SharingUser>;
  requestExhibitionAccess?: Maybe<ExhibitionVisitor>;
  requestJBagotAccess?: Maybe<JbagotVisitor>;
  requestViewerAccess?: Maybe<ViewerAssetVisitor>;
  updateAsset?: Maybe<Asset>;
  updateAssetContext?: Maybe<AssetContext>;
  updateAssetContextByCustomId?: Maybe<AssetContext>;
  updateAssetGroup?: Maybe<AssetGroup>;
  updateCollection?: Maybe<Collection>;
  updateCollectionType?: Maybe<CollectionType>;
  updateEntity?: Maybe<Entity>;
  updateEntityType?: Maybe<EntityType>;
  updateInvoice?: Maybe<Invoice>;
  updateManager?: Maybe<Manager>;
  updateManagerPassword?: Maybe<Scalars['String']>;
  updateMedia?: Maybe<Scalars['Boolean']>;
  updateMediaToDoc?: Maybe<Scalars['Boolean']>;
  updateOrganization?: Maybe<Organization>;
  updatePasswordsUrl?: Maybe<Scalars['Boolean']>;
  updateSecret?: Maybe<Secret>;
  updateTag?: Maybe<Tag>;
  updateVenue?: Maybe<Venue>;
};


export type MutationAddPasswordArgs = {
  collectionId: Scalars['ID'];
  expiration?: InputMaybe<Scalars['Int']>;
  passwordsString: Scalars['String'];
};


export type MutationBatchWriteAssetArgs = {
  list: Array<AssetInput>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBatchWriteAssetGroupArgs = {
  assetGroup: AssetGroupInput;
};


export type MutationBatchWriteCollectionArgs = {
  list: Array<BatchCollectionInputObjectType>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBatchWriteEntityArgs = {
  list: Array<BatchEntityInputObjectType>;
  overwrite?: InputMaybe<Scalars['Boolean']>;
};


export type MutationBatchWriteInvoiceArgs = {
  invoice: InvoiceInput;
};


export type MutationBatchWriteVenueArgs = {
  list: Array<VenueInput>;
};


export type MutationCloneCollectionArgs = {
  Exhibition?: InputMaybe<ExhibitionCollectionInput>;
  ViewingRoom?: InputMaybe<ViewingRoomCollectionInput>;
};


export type MutationCreateAssetArgs = {
  asset: AssetInput;
};


export type MutationCreateAssetContextArgs = {
  assetContext: AssetContextInput;
};


export type MutationCreateAssetContextByCustomIdArgs = {
  assetContext: AssetContextInput;
};


export type MutationCreateAssetGroupArgs = {
  assetGroup: AssetGroupInput;
};


export type MutationCreateCollectionArgs = {
  Exhibition?: InputMaybe<ExhibitionCollectionInput>;
  ViewingRoom?: InputMaybe<ViewingRoomCollectionInput>;
};


export type MutationCreateCollectionTypeArgs = {
  collectionType?: InputMaybe<CollectionTypeInput>;
};


export type MutationCreateEntityArgs = {
  Artist?: InputMaybe<ArtistEntityInput>;
  Culture?: InputMaybe<CultureEntityInput>;
  Date?: InputMaybe<DateEntityInput>;
  Location?: InputMaybe<LocationEntityInput>;
  Material?: InputMaybe<MaterialEntityInput>;
  Other?: InputMaybe<OtherEntityInput>;
  Period?: InputMaybe<PeriodEntityInput>;
  Subculture?: InputMaybe<SubcultureEntityInput>;
  Technique?: InputMaybe<TechniqueEntityInput>;
  Typology?: InputMaybe<TypologyEntityInput>;
};


export type MutationCreateEntityTypeArgs = {
  entityType?: InputMaybe<EntityTypeInput>;
};


export type MutationCreateInvoiceArgs = {
  invoice: InvoiceInput;
};


export type MutationCreateLanguageArgs = {
  language: LanguageInput;
};


export type MutationCreateManagerArgs = {
  appId: Scalars['ID'];
  manager?: InputMaybe<ManagerInput>;
};


export type MutationCreateOrganizationArgs = {
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreateSecretArgs = {
  secret?: InputMaybe<SecretInput>;
};


export type MutationCreateTagArgs = {
  tag?: InputMaybe<TagInput>;
};


export type MutationCreateVenueArgs = {
  venue?: InputMaybe<VenueInput>;
};


export type MutationDeleteAssetArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssetContextArgs = {
  asset: Scalars['ID'];
  collection: Scalars['ID'];
  collectionType: Scalars['String'];
};


export type MutationDeleteAssetContextsArgs = {
  collection: Scalars['ID'];
  collectionType: Scalars['String'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationDeleteAssetGroupArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteAssetGroupsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationDeleteAssetsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  organization?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteCollectionArgs = {
  collectionType: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteCollectionTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCollectionsArgs = {
  collectionType: Scalars['String'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  organization?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteEntitiesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationDeleteEntityArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteEntityTypeArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvoiceArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteInvoicesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationDeleteManagerArgs = {
  appId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationDeleteOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteOrganizationsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationDeleteSecretArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteVenueArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationGenerateSharingTokenArgs = {
  expiring: Scalars['ID'];
};


export type MutationRequestExhibitionAccessArgs = {
  customId: Scalars['ID'];
};


export type MutationRequestViewerAccessArgs = {
  customId: Scalars['ID'];
};


export type MutationUpdateAssetArgs = {
  asset?: InputMaybe<AssetInput>;
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateAssetContextArgs = {
  assetContext?: InputMaybe<AssetContextInput>;
};


export type MutationUpdateAssetContextByCustomIdArgs = {
  assetContext?: InputMaybe<AssetContextInput>;
};


export type MutationUpdateAssetGroupArgs = {
  assetGroup?: InputMaybe<AssetGroupInput>;
  id: Scalars['ID'];
};


export type MutationUpdateCollectionArgs = {
  Exhibition?: InputMaybe<ExhibitionCollectionInput>;
  ViewingRoom?: InputMaybe<ViewingRoomCollectionInput>;
};


export type MutationUpdateCollectionTypeArgs = {
  collectionType?: InputMaybe<CollectionTypeInput>;
  id: Scalars['ID'];
};


export type MutationUpdateEntityArgs = {
  Artist?: InputMaybe<ArtistEntityInput>;
  Culture?: InputMaybe<CultureEntityInput>;
  Date?: InputMaybe<DateEntityInput>;
  Location?: InputMaybe<LocationEntityInput>;
  Material?: InputMaybe<MaterialEntityInput>;
  Other?: InputMaybe<OtherEntityInput>;
  Period?: InputMaybe<PeriodEntityInput>;
  Subculture?: InputMaybe<SubcultureEntityInput>;
  Technique?: InputMaybe<TechniqueEntityInput>;
  Typology?: InputMaybe<TypologyEntityInput>;
};


export type MutationUpdateEntityTypeArgs = {
  entityType?: InputMaybe<EntityTypeInput>;
  id: Scalars['ID'];
};


export type MutationUpdateInvoiceArgs = {
  id: Scalars['ID'];
  invoice?: InputMaybe<InvoiceInput>;
};


export type MutationUpdateManagerArgs = {
  appId: Scalars['ID'];
  manager: ManagerInput;
};


export type MutationUpdateManagerPasswordArgs = {
  appId: Scalars['ID'];
  password: Scalars['String'];
  userId: Scalars['ID'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['ID'];
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdatePasswordsUrlArgs = {
  collectionId: Scalars['ID'];
};


export type MutationUpdateSecretArgs = {
  secret?: InputMaybe<SecretInput>;
};


export type MutationUpdateTagArgs = {
  tag?: InputMaybe<TagInput>;
};


export type MutationUpdateVenueArgs = {
  id: Scalars['ID'];
  venue?: InputMaybe<VenueInput>;
};

export type Organization = {
  __typename?: 'Organization';
  available_languages?: Maybe<Array<Maybe<Language>>>;
  billing_address?: Maybe<Scalars['String']>;
  billing_email?: Maybe<Scalars['String']>;
  billing_phone?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  dark_logo_img?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  enquiries_email?: Maybe<Scalars['String']>;
  favicon_img?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  light_logo_img?: Maybe<Scalars['String']>;
  logo_img?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  signature_img?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  vat_number?: Maybe<Scalars['String']>;
};

export type OrganizationFilteringInput = {
  customId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type OrganizationInput = {
  available_languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  billing_address?: InputMaybe<Scalars['String']>;
  billing_email?: InputMaybe<Scalars['String']>;
  billing_phone?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company_name?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId?: InputMaybe<Scalars['ID']>;
  dark_logo_img?: InputMaybe<Scalars['String']>;
  default_language?: InputMaybe<Scalars['String']>;
  enquiries_email?: InputMaybe<Scalars['String']>;
  favicon_img?: InputMaybe<Scalars['String']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  light_logo_img?: InputMaybe<Scalars['String']>;
  logo_img?: InputMaybe<Scalars['String']>;
  mfa_factors?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  name?: InputMaybe<TranslationInput>;
  phone?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  signature_img?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  vat_number?: InputMaybe<Scalars['String']>;
};

export type OrganizationList = {
  __typename?: 'OrganizationList';
  data?: Maybe<Array<Maybe<Organization>>>;
  meta?: Maybe<PageMeta>;
};

export type Other = Entity & {
  __typename?: 'Other';
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  entityType?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
};

export type OtherEntityInput = {
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type PageMeta = {
  __typename?: 'PageMeta';
  currentPage?: Maybe<Scalars['Int']>;
  lastPage?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type Period = Entity & {
  __typename?: 'Period';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type PeriodEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Price = {
  __typename?: 'Price';
  currency?: Maybe<Scalars['String']>;
  hidden?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Float']>;
};

export type PriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Float']>;
};

export type Query = {
  __typename?: 'Query';
  allCollections?: Maybe<Array<Maybe<Collection>>>;
  allOrganizations?: Maybe<Array<Maybe<Organization>>>;
  allTags?: Maybe<Array<Maybe<Tag>>>;
  allVenues?: Maybe<Array<Maybe<Venue>>>;
  asset?: Maybe<Asset>;
  assetByCustomId?: Maybe<Asset>;
  assetContext?: Maybe<AssetContext>;
  assetContextsByCollectionCustomId?: Maybe<AssetContextsList>;
  assetContextsById?: Maybe<AssetContextsList>;
  assetGroup?: Maybe<AssetGroup>;
  checkPassword?: Maybe<Scalars['Boolean']>;
  checkPasswordById?: Maybe<Scalars['Boolean']>;
  collection?: Maybe<Collection>;
  collectionByCustomId?: Maybe<Collection>;
  collectionNames?: Maybe<Array<Maybe<Collection>>>;
  collectionType?: Maybe<CollectionType>;
  entity?: Maybe<Entity>;
  entityByCustomId?: Maybe<Entity>;
  entityType?: Maybe<EntityType>;
  initExhibition?: Maybe<Collection>;
  initViewingRoom?: Maybe<InitViewingRoom>;
  invoice?: Maybe<Invoice>;
  invoicesByOrganization?: Maybe<Array<Maybe<Invoice>>>;
  lastAssetCustomId?: Maybe<Scalars['String']>;
  lastEntityCustomId?: Maybe<Scalars['String']>;
  listAssetGroups?: Maybe<AssetGroupList>;
  listAssets?: Maybe<AssetsList>;
  listAssetsByCustomId?: Maybe<Array<Maybe<Asset>>>;
  listCollectionTypes?: Maybe<Array<Maybe<CollectionType>>>;
  listCollections?: Maybe<CollectionsList>;
  listEntities?: Maybe<EntitiesList>;
  listEntityNames?: Maybe<Array<Maybe<Entity>>>;
  listEntityTypes?: Maybe<Array<Maybe<EntityType>>>;
  listInvoices?: Maybe<InvoiceList>;
  listLanguages?: Maybe<Array<Maybe<Language>>>;
  listManagers?: Maybe<Users>;
  listOrganizations?: Maybe<OrganizationList>;
  listTagNames?: Maybe<TagsList>;
  listVenues?: Maybe<VenueList>;
  manager?: Maybe<Manager>;
  managerByEmail?: Maybe<Manager>;
  organization?: Maybe<Organization>;
  passwordsByCollection?: Maybe<Array<Maybe<ExhibitionPassword>>>;
  passwordsInfo?: Maybe<Scalars['Boolean']>;
  searchManagers?: Maybe<SearchedUsers>;
  totalManagers?: Maybe<Scalars['Int']>;
  venue?: Maybe<Venue>;
  venuesByOrganization?: Maybe<Array<Maybe<Venue>>>;
};


export type QueryAllCollectionsArgs = {
  collectionType?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
};


export type QueryAllTagsArgs = {
  organization?: InputMaybe<Scalars['String']>;
};


export type QueryAssetArgs = {
  id: Scalars['ID'];
};


export type QueryAssetByCustomIdArgs = {
  customId: Scalars['ID'];
};


export type QueryAssetContextArgs = {
  asset: Scalars['ID'];
  collection: Scalars['ID'];
  collectionType: Scalars['String'];
};


export type QueryAssetContextsByCollectionCustomIdArgs = {
  collectionType: Scalars['String'];
  customId: Scalars['ID'];
  filtering?: InputMaybe<AssetContextFilteringInput>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetContextsByIdArgs = {
  collectionType?: InputMaybe<Scalars['String']>;
  filtering?: InputMaybe<AssetContextFilteringInput>;
  id: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  property?: InputMaybe<IdProperty>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryAssetGroupArgs = {
  id: Scalars['ID'];
};


export type QueryCheckPasswordArgs = {
  collectionId: Scalars['ID'];
  password: Scalars['String'];
};


export type QueryCheckPasswordByIdArgs = {
  collectionId: Scalars['ID'];
  passwordId: Scalars['ID'];
};


export type QueryCollectionArgs = {
  collectionType: Scalars['String'];
  id: Scalars['ID'];
};


export type QueryCollectionByCustomIdArgs = {
  collectionType: Scalars['String'];
  customId: Scalars['ID'];
};


export type QueryCollectionNamesArgs = {
  collectionType?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
};


export type QueryCollectionTypeArgs = {
  id: Scalars['ID'];
};


export type QueryEntityArgs = {
  id: Scalars['ID'];
};


export type QueryEntityByCustomIdArgs = {
  customId: Scalars['ID'];
};


export type QueryEntityTypeArgs = {
  id: Scalars['ID'];
};


export type QueryInitExhibitionArgs = {
  customId: Scalars['ID'];
};


export type QueryInitViewingRoomArgs = {
  id: Scalars['ID'];
  type: Scalars['String'];
};


export type QueryInvoiceArgs = {
  id: Scalars['ID'];
};


export type QueryInvoicesByOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryLastAssetCustomIdArgs = {
  asset_type?: InputMaybe<Scalars['String']>;
};


export type QueryLastEntityCustomIdArgs = {
  customEntityType?: InputMaybe<Scalars['String']>;
};


export type QueryListAssetGroupsArgs = {
  filtering?: InputMaybe<AssetGroupFilteringInput>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListAssetsArgs = {
  filtering?: InputMaybe<AssetFilteringInput>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListAssetsByCustomIdArgs = {
  assetIdList: Array<InputMaybe<Scalars['ID']>>;
};


export type QueryListCollectionsArgs = {
  filtering?: InputMaybe<CollectionFilteringInput>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListEntitiesArgs = {
  filtering?: InputMaybe<EntityFilteringInput>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListInvoicesArgs = {
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListManagersArgs = {
  appId: Scalars['ID'];
  direction?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryListOrganizationsArgs = {
  filtering?: InputMaybe<OrganizationFilteringInput>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryListTagNamesArgs = {
  filtering?: InputMaybe<TagFilteringInput>;
  organization?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryListVenuesArgs = {
  filtering?: InputMaybe<VenueFilteringInput>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
};


export type QueryManagerArgs = {
  appId: Scalars['ID'];
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryManagerByEmailArgs = {
  appId: Scalars['ID'];
  email?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryPasswordsByCollectionArgs = {
  id: Scalars['ID'];
};


export type QueryPasswordsInfoArgs = {
  collectionId: Scalars['ID'];
  passwordsString: Scalars['String'];
};


export type QuerySearchManagersArgs = {
  appId: Scalars['ID'];
  direction?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryTotalManagersArgs = {
  appId: Scalars['ID'];
  organization?: InputMaybe<Scalars['ID']>;
};


export type QueryVenueArgs = {
  id: Scalars['ID'];
};


export type QueryVenuesByOrganizationArgs = {
  organization?: InputMaybe<Scalars['ID']>;
};

export type Question = {
  __typename?: 'Question';
  answers?: Maybe<Array<Maybe<Translation>>>;
  question?: Maybe<Translation>;
};

export type QuestionInput = {
  answers?: InputMaybe<Array<InputMaybe<TranslationInput>>>;
  question?: InputMaybe<TranslationInput>;
};

export enum RoleType {
  Administrator = 'Administrator',
  Superadmin = 'Superadmin',
  Viewer = 'Viewer'
}

export type Room = {
  __typename?: 'Room';
  audio_background?: Maybe<Media>;
  audio_description?: Maybe<Media>;
  boundaries?: Maybe<Boundaries>;
  customId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Translation>;
  viewpointIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type RoomInput = {
  audio_background?: InputMaybe<MediaInput>;
  audio_description?: InputMaybe<MediaInput>;
  boundaries?: InputMaybe<BoundariesInput>;
  customId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<TranslationInput>;
  viewpointIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type RoomsInput = {
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
};

export type Secret = {
  __typename?: 'Secret';
  client_id?: Maybe<Scalars['String']>;
  client_secret?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  resource_id?: Maybe<Scalars['String']>;
};

export type SecretInput = {
  client_id?: InputMaybe<Scalars['String']>;
  client_secret?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  resource_id?: InputMaybe<Scalars['String']>;
};

export enum StatusType {
  Active = 'Active',
  AwaitingPasswordReset = 'Awaiting_password_reset',
  Locked = 'Locked',
  PasswordExpired = 'Password_expired',
  PasswordPending = 'Password_pending',
  SecurityQuestionsRequired = 'Security_questions_required',
  Suspended = 'Suspended',
  Unactivated = 'Unactivated'
}

export type Subculture = Entity & {
  __typename?: 'Subculture';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type SubcultureEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Tag = {
  __typename?: 'Tag';
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  description?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  name?: Maybe<Translation>;
  organization?: Maybe<Organization>;
  type?: Maybe<TagType>;
};

export type TagFilteringInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type TagInput = {
  creation_date?: InputMaybe<Scalars['ID']>;
  customId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<TranslationInput>;
  organization?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TagType>;
};

export enum TagType {
  Artist = 'Artist',
  Character = 'Character',
  Culture = 'Culture',
  Date = 'Date',
  Iconography = 'Iconography',
  Location = 'Location',
  Material = 'Material',
  Movement = 'Movement',
  Other = 'Other',
  Period = 'Period',
  Subculture = 'Subculture',
  Technique = 'Technique',
  Typology = 'Typology'
}

export type TagsList = {
  __typename?: 'TagsList';
  data?: Maybe<Array<Maybe<Tag>>>;
  meta?: Maybe<PageMeta>;
};

export type Technique = Entity & {
  __typename?: 'Technique';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type TechniqueEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Translation = {
  __typename?: 'Translation';
  ca?: Maybe<Scalars['String']>;
  en?: Maybe<Scalars['String']>;
  es?: Maybe<Scalars['String']>;
  it?: Maybe<Scalars['String']>;
};

export type TranslationInput = {
  ca?: InputMaybe<Scalars['String']>;
  en?: InputMaybe<Scalars['String']>;
  es?: InputMaybe<Scalars['String']>;
  it?: InputMaybe<Scalars['String']>;
};

export type Typology = Entity & {
  __typename?: 'Typology';
  MD_bio?: Maybe<Translation>;
  bio?: Maybe<Translation>;
  birth_date?: Maybe<Translation>;
  birth_place?: Maybe<Translation>;
  client_bio?: Maybe<Translation>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  custom_entities?: Maybe<Array<Maybe<CustomEntity>>>;
  death_date?: Maybe<Translation>;
  death_place?: Maybe<Translation>;
  description?: Maybe<Translation>;
  entityType?: Maybe<Scalars['ID']>;
  full_name?: Maybe<Translation>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  media?: Maybe<Array<Maybe<Media>>>;
  name?: Maybe<Translation>;
  nationality?: Maybe<Translation>;
  nickname?: Maybe<Translation>;
  related_entities?: Maybe<Array<Maybe<Entity>>>;
  surname?: Maybe<Translation>;
};

export type TypologyEntityInput = {
  MD_bio?: InputMaybe<TranslationInput>;
  bio?: InputMaybe<LongTranslationInput>;
  birth_date?: InputMaybe<TranslationInput>;
  birth_place?: InputMaybe<TranslationInput>;
  client_bio?: InputMaybe<TranslationInput>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId: Scalars['ID'];
  custom_entities?: InputMaybe<Array<InputMaybe<CustomEntityInput>>>;
  death_date?: InputMaybe<TranslationInput>;
  death_place?: InputMaybe<TranslationInput>;
  description?: InputMaybe<TranslationInput>;
  entityType?: InputMaybe<Scalars['ID']>;
  etag?: InputMaybe<Scalars['String']>;
  full_name?: InputMaybe<TranslationInput>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<InputMaybe<MediaInput>>>;
  name?: InputMaybe<TranslationInput>;
  nationality?: InputMaybe<TranslationInput>;
  nickname?: InputMaybe<TranslationInput>;
  related_entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  surname?: InputMaybe<TranslationInput>;
};

export type Venue = {
  __typename?: 'Venue';
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  description?: Maybe<Translation>;
  dvm_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  last_modified?: Maybe<Scalars['ID']>;
  model3d?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  venueConfigs?: Maybe<Array<Maybe<VenueConfiguration>>>;
};

export type VenueConfiguration = {
  __typename?: 'VenueConfiguration';
  customId?: Maybe<Scalars['String']>;
  dvm_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  model3d?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  rooms?: Maybe<Array<Maybe<Room>>>;
  venue_id?: Maybe<Scalars['ID']>;
};

export type VenueFilteringInput = {
  customId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type VenueInput = {
  creation_date?: InputMaybe<Scalars['ID']>;
  customId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<LongTranslationInput>;
  dvm_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  last_modified?: InputMaybe<Scalars['ID']>;
  model3d?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  venueConfigs?: InputMaybe<Array<InputMaybe<VenueInputConfiguration>>>;
};

export type VenueInputConfiguration = {
  customId?: InputMaybe<Scalars['String']>;
  dvm_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  model3d?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
  rooms?: InputMaybe<Array<InputMaybe<RoomInput>>>;
  venue_id?: InputMaybe<Scalars['ID']>;
};

export type VenueList = {
  __typename?: 'VenueList';
  data?: Maybe<Array<Maybe<Venue>>>;
  meta?: Maybe<PageMeta>;
};

export type ViewingRoom = Collection & {
  __typename?: 'ViewingRoom';
  assetContextsCount?: Maybe<Scalars['Int']>;
  audio_background?: Maybe<Media>;
  audio_description?: Maybe<Media>;
  available_languages?: Maybe<Array<Maybe<Language>>>;
  collectionType?: Maybe<Scalars['ID']>;
  cover_img?: Maybe<Scalars['String']>;
  creation_date?: Maybe<Scalars['ID']>;
  customId?: Maybe<Scalars['ID']>;
  dark_logo_img?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  description?: Maybe<Translation>;
  disable_audios?: Maybe<Scalars['Boolean']>;
  dvm_set_id?: Maybe<Scalars['String']>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  etag?: Maybe<Scalars['String']>;
  exhibitionType?: Maybe<ExhibitionType>;
  id?: Maybe<Scalars['ID']>;
  init_pano?: Maybe<Scalars['String']>;
  init_questions?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Translation>;
  last_modified?: Maybe<Scalars['ID']>;
  light_logo_img?: Maybe<Scalars['String']>;
  login_applied?: Maybe<Scalars['Boolean']>;
  logo_img?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
  organization?: Maybe<Organization>;
  organizer?: Maybe<ExhibitionOrganizer>;
  password?: Maybe<Scalars['String']>;
  passwords?: Maybe<Translation>;
  questions?: Maybe<Array<Maybe<Question>>>;
  related_links?: Maybe<Array<Maybe<CollectionRelatedLink>>>;
  sharedOrganizations?: Maybe<Array<Maybe<Organization>>>;
  styling?: Maybe<CollectionStyling>;
  subtitle?: Maybe<Translation>;
  theme_song?: Maybe<Scalars['String']>;
  title?: Maybe<Translation>;
  type?: Maybe<ViewingRoomType>;
  venueConfig?: Maybe<VenueConfiguration>;
  viewer?: Maybe<Scalars['String']>;
  visibility?: Maybe<CollectionVisibility>;
  web_entities?: Maybe<Array<Maybe<WebEntity>>>;
};

export type ViewingRoomCollectionInput = {
  assetContexts?: InputMaybe<Array<InputMaybe<AssetContextsInput>>>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  audio_background?: InputMaybe<MediaInput>;
  audio_description?: InputMaybe<MediaInput>;
  available_languages?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  collectionType?: InputMaybe<Scalars['ID']>;
  cover_img?: InputMaybe<Scalars['String']>;
  creation_date?: InputMaybe<Scalars['ID']>;
  customId?: InputMaybe<Scalars['ID']>;
  dark_logo_img?: InputMaybe<Scalars['String']>;
  default_language?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<LongTranslationInput>;
  disable_audios?: InputMaybe<Scalars['Boolean']>;
  dvm_set_id?: InputMaybe<Scalars['String']>;
  entities?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  etag?: InputMaybe<Scalars['String']>;
  exhibitionType?: InputMaybe<ExhibitionType>;
  id?: InputMaybe<Scalars['ID']>;
  init_pano?: InputMaybe<Scalars['String']>;
  init_questions?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<TranslationInput>;
  last_modified?: InputMaybe<Scalars['ID']>;
  light_logo_img?: InputMaybe<Scalars['String']>;
  login_applied?: InputMaybe<Scalars['Boolean']>;
  logo_img?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
  organization?: InputMaybe<Scalars['ID']>;
  organizer?: InputMaybe<ExhibitionOrganizerInput>;
  password?: InputMaybe<Scalars['String']>;
  passwords?: InputMaybe<TranslationInput>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  related_links?: InputMaybe<Array<InputMaybe<CollectionInputRelatedLink>>>;
  rooms?: InputMaybe<Array<InputMaybe<RoomsInput>>>;
  sharedOrganizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  styling?: InputMaybe<CollectionStylingInput>;
  subtitle?: InputMaybe<TranslationInput>;
  theme_song?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<TranslationInput>;
  type?: InputMaybe<ViewingRoomInputType>;
  venueConfig?: InputMaybe<Scalars['ID']>;
  viewer?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<CollectionVisibility>;
  web_entities?: InputMaybe<Array<InputMaybe<WebEntityInput>>>;
};

export type WebEntity = {
  __typename?: 'WebEntity';
  customId?: Maybe<Scalars['ID']>;
  entityType?: Maybe<Scalars['String']>;
  name?: Maybe<Translation>;
};

export type WebEntityInput = {
  customId?: InputMaybe<Scalars['ID']>;
  entityType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<TranslationInput>;
};

export enum AssetGroupInputType {
  Artworks = 'artworks',
  Pointsofinterest = 'pointsofinterest'
}

export enum AssetGroupType {
  Artworks = 'artworks',
  Pointsofinterest = 'pointsofinterest'
}

export type BatchAssetErrorObj = {
  __typename?: 'batchAssetErrorObj';
  element?: Maybe<Asset>;
  error?: Maybe<Scalars['String']>;
};

export type BatchAssets = {
  __typename?: 'batchAssets';
  errors?: Maybe<Array<Maybe<BatchAssetErrorObj>>>;
  list?: Maybe<Array<Maybe<Asset>>>;
};

export type BatchCollectionErrorObj = {
  __typename?: 'batchCollectionErrorObj';
  element?: Maybe<Collection>;
  error?: Maybe<Scalars['String']>;
};

export type BatchCollections = {
  __typename?: 'batchCollections';
  errors?: Maybe<Array<Maybe<BatchCollectionErrorObj>>>;
  list?: Maybe<Array<Maybe<Collection>>>;
};

export type BatchEntities = {
  __typename?: 'batchEntities';
  errors?: Maybe<Array<Maybe<BatchEntityErrorObj>>>;
  list?: Maybe<Array<Maybe<Entity>>>;
};

export type BatchEntityErrorObj = {
  __typename?: 'batchEntityErrorObj';
  element?: Maybe<Entity>;
  error?: Maybe<Scalars['String']>;
};

export type ExhibitionVisitor = {
  __typename?: 'exhibitionVisitor';
  accessToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export enum FontStyleInputType {
  Montserrat = 'montserrat',
  PlantinMt = 'plantin_mt',
  PlayfairDisplay = 'playfair_display'
}

export enum FontStyleType {
  Montserrat = 'montserrat',
  PlantinMt = 'plantin_mt',
  PlayfairDisplay = 'playfair_display'
}

export enum IdProperty {
  Asset = 'asset',
  Collection = 'collection'
}

export type InitViewingRoom = {
  __typename?: 'initViewingRoom';
  collection?: Maybe<Collection>;
  organization?: Maybe<Organization>;
};

export enum InvoiceTaxEnum {
  Iva = 'iva',
  Rebu = 'rebu'
}

export enum InvoiceTaxInputEnum {
  Iva = 'iva',
  Rebu = 'rebu'
}

export type JbagotVisitor = {
  __typename?: 'jbagotVisitor';
  accessToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type SearchedUsers = {
  __typename?: 'searchedUsers';
  managers?: Maybe<Array<Maybe<Manager>>>;
  pagination?: Maybe<ManagerPagination>;
};

export type SharingUser = {
  __typename?: 'sharingUser';
  accessToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type Users = {
  __typename?: 'users';
  managers?: Maybe<Array<Maybe<Manager>>>;
  pagination?: Maybe<ManagerPagination>;
};

export type ViewerAssetVisitor = {
  __typename?: 'viewerAssetVisitor';
  accessToken?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export enum ViewingRoomInputType {
  Basic = 'basic',
  Catalog = 'catalog',
  Web = 'web'
}

export enum ViewingRoomType {
  Basic = 'basic',
  Catalog = 'catalog',
  Web = 'web'
}

export type GetAssetPreviewDataQueryVariables = Exact<{
  id: Scalars['ID'];
  property: IdProperty;
  collectionType: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  queryLimit?: InputMaybe<Scalars['Int']>;
}>;


export type GetAssetPreviewDataQuery = { __typename?: 'Query', assetContextsById?: { __typename?: 'AssetContextsList', data?: Array<{ __typename?: 'AssetContext', id?: string | null, sortIndex?: number | null, asset?: { __typename?: 'Asset', id: string, customId?: string | null, client_reference?: string | null, visibility?: AssetVisibility | null, name?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null, entities?: Array<{ __typename?: 'Artist', entityType?: string | null, id?: string | null, customId?: string | null, surname?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Culture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Date', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Location', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Material', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Other', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Period', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Subculture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Technique', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Typology', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, custom_entities?: Array<{ __typename?: 'CustomEntity', type?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', id?: string | null, type?: MediaType | null, name?: string | null, path?: string | null, thumbnail?: string | null, view_image?: string | null, originalName?: string | null, hd?: string | null, model3d?: string | null, description?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null } | null> | null } | null } | null> | null, meta?: { __typename?: 'PageMeta', total?: number | null, perPage?: number | null, currentPage?: number | null, lastPage?: number | null } | null } | null };

export type GetAssetByCustomIdQueryVariables = Exact<{
  customId: Scalars['ID'];
}>;


export type GetAssetByCustomIdQuery = { __typename?: 'Query', assetByCustomId?: { __typename?: 'Asset', id: string, customId?: string | null, client_reference?: string | null, current_gmaps?: string | null, original_gmaps?: string | null, sale_status?: string | null, visibility?: AssetVisibility | null, etag?: string | null, organization?: { __typename?: 'Organization', id?: string | null, enquiries_email?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null, name?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null, description?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null, tags?: Array<{ __typename?: 'Tag', id?: string | null, customId?: string | null, type?: TagType | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, description?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | null> | null, parent?: { __typename?: 'Asset', id: string, customId?: string | null, visibility?: AssetVisibility | null, name?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null } | null, children?: Array<{ __typename?: 'Asset', id: string, customId?: string | null, visibility?: AssetVisibility | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, description?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, entities?: Array<{ __typename?: 'Artist', entityType?: string | null, id?: string | null, customId?: string | null, surname?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Culture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Date', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Location', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Material', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Other', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Period', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Subculture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Technique', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Typology', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, custom_entities?: Array<{ __typename?: 'CustomEntity', type?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', id?: string | null, type?: MediaType | null, name?: string | null, path?: string | null, thumbnail?: string | null, view_image?: string | null, url?: string | null, hd?: string | null, model3d?: string | null, description?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null } | null> | null, dimensions?: { __typename?: 'Dimension', width?: number | null, height?: number | null, depth?: number | null, units?: string | null } | null, custom_dimensions?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, condition?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, series?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, exhibited?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, provenance?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, current_location?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, original_location?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, publications?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, bibliography_reference?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, scientific_tests?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, observations?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, signed_dated_labeled?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, inscriptions?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, price?: { __typename?: 'AssetPrice', sale_price?: { __typename?: 'Price', currency?: string | null, value?: number | null } | null } | null } | null };

export type GetAssetPreviewByCustomIdQueryVariables = Exact<{
  customId: Scalars['ID'];
}>;


export type GetAssetPreviewByCustomIdQuery = { __typename?: 'Query', assetByCustomId?: { __typename?: 'Asset', id: string, customId?: string | null, name?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null, entities?: Array<{ __typename?: 'Artist', entityType?: string | null, id?: string | null, customId?: string | null, surname?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Culture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Date', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Location', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Material', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Other', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Period', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Subculture', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Technique', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | { __typename?: 'Typology', entityType?: string | null, id?: string | null, customId?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, custom_entities?: Array<{ __typename?: 'CustomEntity', type?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null } | null> | null, media?: Array<{ __typename?: 'Media', id?: string | null, type?: MediaType | null, name?: string | null, path?: string | null, thumbnail?: string | null, view_image?: string | null, url?: string | null, hd?: string | null, model3d?: string | null, description?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null } | null> | null } | null };

export type GetCollectionByCustomIdQueryVariables = Exact<{
  customId: Scalars['ID'];
  collectionType: Scalars['String'];
}>;


export type GetCollectionByCustomIdQuery = { __typename?: 'Query', collectionByCustomId?: { __typename?: 'Exhibition', id?: string | null, customId?: string | null, collectionType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, web_entities?: Array<{ __typename?: 'WebEntity', customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | null> | null } | { __typename?: 'ViewingRoom', id?: string | null, customId?: string | null, collectionType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, web_entities?: Array<{ __typename?: 'WebEntity', customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | null> | null } | null };

export type GetEntityQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEntityQuery = { __typename?: 'Query', entity?: { __typename?: 'Artist', id?: string | null, customId?: string | null, entityType?: string | null, media?: Array<{ __typename?: 'Media', id?: string | null, type?: MediaType | null, name?: string | null, path?: string | null, thumbnail?: string | null, url?: string | null, description?: { __typename?: 'Translation', en?: string | null, es?: string | null, ca?: string | null } | null } | null> | null, surname?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, MD_bio?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, bio?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, birth_date?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, birth_place?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, client_bio?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, death_place?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, death_date?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, nationality?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, nickname?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Culture', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Date', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Location', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Material', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Other', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Period', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Subculture', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Technique', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | { __typename?: 'Typology', id?: string | null, customId?: string | null, entityType?: string | null, name?: { __typename?: 'Translation', ca?: string | null, en?: string | null, es?: string | null } | null } | null };

export type GetOrganizationByCustomIdQueryVariables = Exact<{
  customId: Scalars['String'];
}>;


export type GetOrganizationByCustomIdQuery = { __typename?: 'Query', listOrganizations?: { __typename?: 'OrganizationList', data?: Array<{ __typename?: 'Organization', id?: string | null, customId?: string | null, default_language?: string | null, logo_img?: string | null, light_logo_img?: string | null, dark_logo_img?: string | null, enquiries_email?: string | null, name?: { __typename?: 'Translation', ca?: string | null, es?: string | null, en?: string | null } | null, available_languages?: Array<{ __typename?: 'Language', id?: string | null, name?: string | null } | null> | null } | null> | null } | null };

export const GetAssetPreviewDataDocument = gql`
    query getAssetPreviewData($id: ID!, $property: idProperty!, $collectionType: String!, $page: Int, $queryLimit: Int) {
  assetContextsById(
    id: $id
    property: $property
    collectionType: $collectionType
    page: $page
    queryLimit: $queryLimit
  ) {
    data {
      id
      sortIndex
      asset {
        id
        customId
        name {
          en
          es
          ca
        }
        client_reference
        entities {
          entityType
          name {
            ca
            es
            en
          }
          id
          customId
          ... on Artist {
            surname {
              ca
              en
              es
            }
          }
        }
        custom_entities {
          type
          name {
            ca
            es
            en
          }
        }
        media {
          id
          type
          name
          path
          thumbnail
          view_image
          originalName
          description {
            en
            es
            ca
          }
          hd
          model3d
        }
        visibility
      }
    }
    meta {
      total
      perPage
      currentPage
      lastPage
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetPreviewDataGQL extends Apollo.Query<GetAssetPreviewDataQuery, GetAssetPreviewDataQueryVariables> {
    document = GetAssetPreviewDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetByCustomIdDocument = gql`
    query getAssetByCustomId($customId: ID!) {
  assetByCustomId(customId: $customId) {
    id
    customId
    client_reference
    organization {
      id
      name {
        ca
        es
        en
      }
      enquiries_email
    }
    name {
      en
      es
      ca
    }
    description {
      en
      es
      ca
    }
    tags {
      id
      customId
      type
      name {
        ca
        en
        es
      }
      description {
        ca
        en
        es
      }
    }
    parent {
      id
      customId
      name {
        en
        es
        ca
      }
      visibility
    }
    children {
      id
      customId
      name {
        ca
        es
        en
      }
      description {
        ca
        es
        en
      }
      visibility
    }
    entities {
      entityType
      name {
        ca
        es
        en
      }
      id
      customId
      ... on Artist {
        surname {
          ca
          en
          es
        }
      }
    }
    custom_entities {
      type
      name {
        ca
        es
        en
      }
    }
    media {
      id
      type
      name
      path
      thumbnail
      view_image
      url
      description {
        en
        es
        ca
      }
      hd
      model3d
    }
    dimensions {
      width
      height
      depth
      units
    }
    custom_dimensions {
      ca
      es
      en
    }
    condition {
      ca
      es
      en
    }
    series {
      ca
      es
      en
    }
    exhibited {
      ca
      es
      en
    }
    provenance {
      ca
      es
      en
    }
    current_location {
      ca
      es
      en
    }
    current_gmaps
    original_location {
      ca
      es
      en
    }
    original_gmaps
    publications {
      ca
      es
      en
    }
    bibliography_reference {
      ca
      es
      en
    }
    scientific_tests {
      ca
      es
      en
    }
    observations {
      ca
      es
      en
    }
    signed_dated_labeled {
      ca
      es
      en
    }
    inscriptions {
      ca
      es
      en
    }
    price {
      sale_price {
        currency
        value
      }
    }
    sale_status
    visibility
    etag
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetByCustomIdGQL extends Apollo.Query<GetAssetByCustomIdQuery, GetAssetByCustomIdQueryVariables> {
    document = GetAssetByCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAssetPreviewByCustomIdDocument = gql`
    query getAssetPreviewByCustomId($customId: ID!) {
  assetByCustomId(customId: $customId) {
    id
    customId
    name {
      en
      es
      ca
    }
    entities {
      entityType
      name {
        ca
        es
        en
      }
      id
      customId
      ... on Artist {
        surname {
          ca
          en
          es
        }
      }
    }
    custom_entities {
      type
      name {
        ca
        es
        en
      }
    }
    media {
      id
      type
      name
      path
      thumbnail
      view_image
      url
      description {
        en
        es
        ca
      }
      hd
      model3d
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssetPreviewByCustomIdGQL extends Apollo.Query<GetAssetPreviewByCustomIdQuery, GetAssetPreviewByCustomIdQueryVariables> {
    document = GetAssetPreviewByCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCollectionByCustomIdDocument = gql`
    query getCollectionByCustomId($customId: ID!, $collectionType: String!) {
  collectionByCustomId(customId: $customId, collectionType: $collectionType) {
    id
    customId
    collectionType
    name {
      ca
      es
      en
    }
    web_entities {
      customId
      name {
        ca
        en
        es
      }
      entityType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCollectionByCustomIdGQL extends Apollo.Query<GetCollectionByCustomIdQuery, GetCollectionByCustomIdQueryVariables> {
    document = GetCollectionByCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEntityDocument = gql`
    query getEntity($id: ID!) {
  entity(id: $id) {
    id
    customId
    name {
      ca
      en
      es
    }
    entityType
    ... on Artist {
      media {
        id
        type
        name
        path
        thumbnail
        url
        description {
          en
          es
          ca
        }
      }
      surname {
        ca
        en
        es
      }
      MD_bio {
        ca
        en
        es
      }
      bio {
        ca
        en
        es
      }
      birth_date {
        ca
        en
        es
      }
      birth_place {
        ca
        en
        es
      }
      client_bio {
        ca
        en
        es
      }
      death_place {
        ca
        en
        es
      }
      death_date {
        ca
        en
        es
      }
      nationality {
        ca
        en
        es
      }
      nickname {
        ca
        en
        es
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEntityGQL extends Apollo.Query<GetEntityQuery, GetEntityQueryVariables> {
    document = GetEntityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationByCustomIdDocument = gql`
    query getOrganizationByCustomId($customId: String!) {
  listOrganizations(filtering: {customId: $customId}) {
    data {
      id
      customId
      name {
        ca
        es
        en
      }
      default_language
      available_languages {
        id
        name
      }
      logo_img
      light_logo_img
      dark_logo_img
      enquiries_email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationByCustomIdGQL extends Apollo.Query<GetOrganizationByCustomIdQuery, GetOrganizationByCustomIdQueryVariables> {
    document = GetOrganizationByCustomIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }